import { CALL_API } from 'redux-api-middleware';

export const REQUEST_GET = Symbol('REQUEST_GET');
export const SUCCESS_GET = Symbol('SUCCESS_GET');
export const FAILURE_GET = Symbol('FAILURE_GET');

export const REQUEST_POST = Symbol('REQUEST_POST');
export const SUCCESS_POST = Symbol('SUCCESS_POST');
export const FAILURE_POST = Symbol('FAILURE_POST');

export const REQUEST_UPDATE = Symbol('REQUEST_UPDATE');
export const SUCCESS_UPDATE = Symbol('SUCCESS_UPDATE');
export const FAILURE_UPDATE = Symbol('FAILURE_UPDATE');

export const UPDATE_CURRENT_ANSWER = Symbol('UPDATE_CURRENT_ANSWER');
export const UPDATE_SAVE_STATE = Symbol('UPDATE_SAVE_STATE');

/**
 * @description
 * Gets the user data required for every page on the site
 *
 * @returns {{}}
 */
export function getResults () {
	return {
		[CALL_API]: {
			endpoint: `${process.env.API_URI}/api/results`,
			method: 'GET',
			headers: {
				'Accept': 'application/json'
			},
			types: [
				REQUEST_GET,
				SUCCESS_GET,
				FAILURE_GET,
			],
		}
	};
}

export function createResults (body) {
	return {
		[CALL_API]: {
			endpoint: `${process.env.API_URI}/api/results`,
			method: 'POST',
			body: JSON.stringify(body),
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			types: [
				REQUEST_POST,
				SUCCESS_POST,
				FAILURE_POST,
			],
		}
	};
}

export function updateResults (body) {
	return {
		[CALL_API]: {
			endpoint: `${process.env.API_URI}/api/results`,
			method: 'PUT',
			body: JSON.stringify(body),
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			types: [
				{
					type: REQUEST_UPDATE,
					meta: body,
				},
				{
					type: SUCCESS_UPDATE,
					meta: body,
				},
				{
					type: FAILURE_UPDATE,
					meta: body
				},
			],
		}
	};
}

export function updateCurrentAnswer (answer) {
	return {
		type: UPDATE_CURRENT_ANSWER,
		answer
	}
}

export function updateSaveState (save) {
	return {
		type: UPDATE_SAVE_STATE,
		save
	}
}
